import { createFileRoute } from "@tanstack/react-router";
import { requerirEdicionDeSolicitud } from "@/features/solicitudes/utils/guard-edicion";
import { SeleccionarContratoAnualizadoPage } from "@/features/seleccionar-contrato-anualizado/components/SeleccionarContratoAnualizadoPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert, WizardPasoSkeleton } from "@/components/ui";

/**
 * Ruta `/solicitudes/$id/contrato-anualizado` · paso previo al CFDI del tipo
 * Contrato Anualizado. Loader precarga la solicitud.
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/contrato-anualizado")({
  beforeLoad: requerirEdicionDeSolicitud,
  loader: ({ context: { queryClient }, params: { id } }) => queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: SeleccionarContratoAnualizadoPage,
  pendingComponent: WizardPasoSkeleton,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
